/* FoldPanel: the row grows from 0fr to 1fr in 0.36s on the sheet curve. */
.panel {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 0.36s cubic-bezier(0.32, 0.72, 0, 1);
  width: 100%;
}

.panel[data-open] { grid-template-rows: 1fr; }

.inner {
  min-height: 0;
  overflow: hidden;
}
